import http from '@/service/http'
import * as firebase from 'firebase'
import localforage from 'localforage'
import store from '@/store'
/*
var firebaseConfig = {
  apiKey: 'AIzaSyCBKGT-OeolZoVRvMJiI_djhMQMaVGRk2c',
  authDomain: 'royal-s-bank.firebaseapp.com',
  databaseURL: 'https://royal-s-bank.firebaseio.com',
  projectId: 'royal-s-bank',
  storageBucket: 'royal-s-bank.appspot.com',
  messagingSenderId: '860080580404',
  appId: '1:860080580404:web:05f27150d64052aaee6761'
}
*/

var firebaseConfig = {
  apiKey: 'AIzaSyA0tk4AAg_T_VDhGAse8asneGnuD3gm7MY',
  authDomain: 'royal-pag.firebaseapp.com',
  databaseURL: 'https://royal-pag.firebaseio.com',
  projectId: 'royal-pag',
  storageBucket: 'royal-pag.appspot.com',
  messagingSenderId: '416604021561',
  cloudfunctionlink: 'https://us-central1-royal-pag.cloudfunctions.net/'
}

// Initialize Firebase
firebase.initializeApp(firebaseConfig)

const fetchOne = async (context, url) => {
  const response = await http.get(url)
  if (response !== null) {
    return Promise.resolve(response.data.data)
  }
}

const fetch = async ({ commit }, {url, action}) => {
  const response = await http.get(url)
  if (response !== null) {
    commit(action, response.data.data)
    return Promise.resolve(response.data.data)
  }
}

const save = async (context, obj) => {
  const { verb, url, entity } = obj
  const response = await http[verb](url, entity)

  if (response !== null) {
    return Promise.resolve(response.data.data)
  }
}

const update = ({ commit, state }, {mutation, obj}) => {
  commit(mutation, obj)
}

const remove = async (context, url) => {
  const response = await http.delete(url)
  if (response !== null) {
    return Promise.resolve(response.data.data)
  }
}

const setUsuario = async ({ commit, state }, vpUser) => {
  
  const response = await http.get('/usuario/' + vpUser)
  if (response !== null) {
  
    store.dispatch('setMenu', response.data.data.menu.data)
    commit('SET_USUARIO', response.data.data)
    localforage.setItem('user', response.data.data)

    return Promise.resolve(response.data.data)
  }
}

const setUsuarioStorage = async ({ commit, state }, user) => {
 
  if (user) {

    store.dispatch('setMenu', user.menu.data)
    commit('SET_USUARIO', user)

    return Promise.resolve(user)
  }
}


const verificaUsuario = async ({ commit, state }, vpUser) => {
  // console.log('store-setUsuario-entrou', vpUser)
  const response = await http.get('/usuario/verificarSeUsuarioExiste/' + vpUser)
  if (response !== null) {
    // console.log('store-setUsuario-response', response.data.data)
    commit('SET_USUARIO', response.data.data)
    return Promise.resolve(response.data.data)
  }
}

const loginFirebase = async (context, obj) => {
  try {
    // console.log('obj: ' + JSON.stringify(obj))
    const { login, senha } = obj
    // console.log('login: ' + login + ' - ' + senha)
    await firebase.auth().signInWithEmailAndPassword(login, senha)
  } catch (e) {
    console.log('erro login firebase: ' + e)
    return e
  }
  return 0
}

export default {
  fetch,
  fetchOne,
  save,
  update,
  remove,
  setUsuario,
  setUsuarioStorage,
  verificaUsuario,
  loginFirebase
}



// WEBPACK FOOTER //
// ./src/features/auth/store/actions.js